<template>
    <b-modal id="editModal" ref="modal" title="Edit ChemicalClassification" v-model="show" @ok="handleSubmit" @hide="close" @shown="focusNameInput">

        <div class="form-group">
            <label>Chemical Classification Name</label>
            <div class="position-relative">
                <input type="text" ref="nameInput" name="name" v-validate="{required: true}" class="form-control" v-model="name">
                <div class="invalid-feedback" v-if="errors.has('name')">{{ errors.first('name') }}</div>
                <i class="form-group__bar"></i>
            </div>
        </div>

        <template slot="modal-footer">
            <button class="btn btn-link text-danger mr-auto" @click="handleDelete" v-if="!classification.deleted_at">
                Disable
            </button>
            <button class="btn btn-link text-danger mr-auto" @click="handleRestore" v-if="classification.deleted_at">
                Restore
            </button>
            <button class="btn btn-secondary" @click="close">
                Cancel
            </button>
            <button class="btn btn-primary" :disabled="okDisabled" @click="handleSubmit">
                Save
            </button>
        </template>
    </b-modal>
</template>


<script>
import deleteChemicalClassificationMutation from '@views/ChemicalClassifications/EditModal/mutationDeleteChemicalClassification.graphql';
import restoreChemicalClassificationMutation from '@views/ChemicalClassifications/EditModal/mutationRestoreChemicalClassification.graphql';
import updateChemicalClassificationMutation from '@views/ChemicalClassifications/EditModal/mutationUpdateChemicalClassification.graphql';

export default {
  name: 'edit-modal',
  apollo: {},
  props: {
    classification: {
      type: Object,
      required: true,
    },
    close: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      name: this.classification.name,
      show: true,
      loading: 0,
    };
  },
  computed: {
    okDisabled() {
      return this.name.length === 0;
    },
  },
  methods: {
    handleSubmit() {
      if (this.okDisabled) {
        return false;
      }
      this.errors.remove('global');
      this.$validator.validateAll().then(validationWasSuccessful => {
        if (!validationWasSuccessful) {
          return;
        }

        this.$apollo
          .mutate({
            mutation: updateChemicalClassificationMutation,
            variables: {
              input: {
                id: this.classification.id,
                name: this.name,
              },
            },
            optimisticResponse: {
              __typename: 'Mutation',
              updateChemicalClassification: {
                ...this.classification,
                name: this.name,
              },
            },
          })
          .then(() => {
            this.$notifySuccess('Chemical classification updated!');
            this.close();
          })
          .catch(err => {
            this.$mapGraphQLError(err);
          })
          .catch(err => {
            console.error(err);
            this.$notifyFailure(
              'Unfortunately, we were unable to do that!',
            );
          });
      });
    },
    handleDelete() {
      this.$apollo
        .mutate({
          mutation: deleteChemicalClassificationMutation,
          variables: {
            input: {
              id: this.classification.id,
            },
          },
        })
        .then(() => {
          this.$notifySuccess('Chemical classification disabled!');
          this.close();
        })
        .catch(err => {
          this.$mapGraphQLError(err);
        })
        .catch(err => {
          console.error(err);
          this.$notifyFailure(
            'Unfortunately, we were unable to do that!',
          );
        });
    },
    handleRestore() {
      this.$apollo
        .mutate({
          mutation: restoreChemicalClassificationMutation,
          variables: {
            input: {
              id: this.classification.id,
            },
          },
          optimisticResponse: {
            __typename: 'Mutation',
            restoreChemicalClassification: {
              ...this.classification,
              deleted_at: null,
            },
          },
        })
        .then(() => {
          this.$notifySuccess('Chemical classification restored!');
          this.close();
        })
        .catch(err => {
          this.$mapGraphQLError(err);
        })
        .catch(err => {
          console.error(err);
          this.$notifyFailure(
            'Unfortunately, we were unable to do that!',
          );
        });
    },
    focusNameInput() {
      this.$refs.nameInput.focus();
    },
  },
};
</script>
